// Community/contributor users are routed to their own CMS + dashboard instances.
export function getCmsUrl(config, { isCommunityUser, isContributorUser } = {}) {
  if (isCommunityUser) {
    return config.community_url;
  }
  if (isContributorUser) {
    return config.contributors_url;
  }
  return config.cms_url;
}

export function getDashbirdUrl(
  config,
  { isCommunityUser, isContributorUser } = {},
) {
  return isCommunityUser || isContributorUser
    ? config.dashbird_community_url
    : config.dashbird_url;
}
